import React from "react";
import { Subscribe } from "unstated";
import PlayerContainer from "../state";


export class Buttons extends React.Component {
    
    render() {
        const decorationClass = { "mandara": "is-info", "madhya": "is-primary", "taara": "is-danger" };
        return (<>
            <Subscribe to={[PlayerContainer]}>
                {playSwara => (
                    <div className="buttons">
                        {playSwara.state.swaras.map((s) => {
                            let isHidden = (s.sthana === "mandara" && !playSwara.state.showMS) ? "is-hidden" : "";
                            let isHiddenT = (s.sthana === "taara" && !playSwara.state.showTS) ? "is-hidden" : "";
                    
                            console.log("showed in buttons", isHidden);
                            if (s.altSwara !== undefined) {
                                return (
                                    <div>
                                        <button className={`button is-outlined ${decorationClass[s.sthana]} ${isHidden} ${isHiddenT}`}
                                            onClick={() => playSwara.addSwara(s.swara)}>{s.swara}</button>
                                        <br />
                                        <button className={`button ${decorationClass[s.sthana]} ${isHidden} ${isHiddenT}`}
                                            onClick={() => playSwara.addSwara(s.altSwara)}>{s.altSwara}</button>
                                    </div>
                                )
                            }
                            return (<button className={`button is-outlined ${decorationClass[s.sthana]} ${isHidden} ${isHiddenT}`}
                                onClick={() => playSwara.addSwara(s.swara)}>{s.swara}</button>)
                        }
                        )}
                        <button className={`button is-primary is-outlined`} style={{ fontWeight: "bolder", fontSize: "large" }} onClick={() => playSwara.addSwara(",")}>,</button>

                        {/* {swaras.map((swaram) => {
          if (swaram.sthana === "mandara")
          {
          return <button className="button is-info is-outlined">{swaram.swara}</button>
          
        }
          else if (swaram.sthana === "madhya"){
            return <button className="button is-primary is-outlined">{swaram.swara}</button>
          }
          return <button className="button is-danger is-outlined">{swaram.swara}</button>
  
        })} */}
                    </div>
                )
                }
            </Subscribe>
        </>
        )
    }
}